// require('dotenv').config();
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./store";
import { Provider } from "react-redux";
import { sendToVercelAnalytics } from './vitals';
import { init as initStickyEnc } from "./stickyEnc";
import { HashRouter as Router } from 'react-router-dom';
initStickyEnc();

ReactDOM.render(
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>,
  document.getElementById('root')
);

reportWebVitals(sendToVercelAnalytics);
